/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Realtime Schema Projection
 * Frontend-only aliases for realtime payload validation.
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const SupplierFunctionId = zod.uuid().describe("Supplier Function identity.");

export type SupplierFunctionId = zod.input<typeof SupplierFunctionId>;
export type SupplierFunctionIdOutput = zod.output<typeof SupplierFunctionId>;
